/**
 * 池长路由
 */
const HeadmanRouter = {
  path: 'headman',
  name: 'Headman',
  meta: {
    requiresAuth: false,
    leftMenu: true          // false表示不需要左边菜单栏
  },
  component: () => import('@/views/Headman/index')
}
export default HeadmanRouter
